import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuthStore } from "../../stores/authStore";
import { useProfile } from "../../hooks/useProfile";
import { NotificationDropdown } from "../notifications/NotificationDropdown";
import { SettingsModal } from "../modal/SettingsModal";
import { IconButton } from "../IconButton";
import { UserInfo } from "../UserInfo";
import gearSixIcon from "../../icons/svg/gear-six.svg";

export const Navbar: React.FC = () => {
  const { status, signOut } = useAuthStore();
  const { data: profile } = useProfile();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  return (
    <>
    <header className="ob-nav">
      <div className="ob-nav-inner">
        <Link to="/" className="ob-logo">
          <span className="ob-logo-mark">
            <span className="ob-logo-glyph">OB</span>
          </span>
          <span>Orderbook</span>
        </Link>
        <div className="ob-nav-actions">
          {status === "authenticated" && (
            <>
                <UserInfo profile={profile} />
                <NotificationDropdown />
                <IconButton
                  icon={gearSixIcon}
                  alt="Settings"
                  onClick={() => setIsSettingsOpen(true)}
                  aria-label="Settings"
                />
              <button
                type="button"
                className="ob-button ob-button-ghost"
                onClick={() => {
                  void signOut();
                }}
              >
                Sign out
              </button>
            </>
          )}
          {status !== "authenticated" && (
            <Link to="/login" className="ob-button ob-button-ghost">
              Sign in
            </Link>
          )}
        </div>
      </div>
    </header>
      <SettingsModal isOpen={isSettingsOpen} onClose={() => setIsSettingsOpen(false)} />
    </>
  );
};

